<template lang='pug'>
  script(type='application/ld+json' v-text='productsCollectionSchema' v-if='productsCount > 0')
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { humanizePrice } from '@/modules/services/price-support'

export default {
  name: 'ProductsJsonSeoSchema',

  computed: {
    ...mapState({
      entity: state => state.product.entity,
      entityType: state => state.product.entityType,
      entityLoaded: state => state.product.entityLoaded,
      products: state => state.product.products,
      productsCount: state => state.product.productsCount
    }),

    ...mapGetters([
      'activeVariantForProduct',
      'brandForProduct'
    ]),

    isCategory () {
      return this.entityLoaded && this.entityType === 'categories'
    },

    productsCollectionSchema () {
      const category = this.isCategory ? this.entity.attributes['label'] : null
      return this.products.map(product => this.productSchema(product, category))
    }
  },

  methods: {
    productSchema (product, category) {
      const schema = {
        '@context': 'http://schema.org/',
        '@type': 'Product',
        'name': product.attributes['name'],
        'image': product.attributes['image-urls'][0],
        'brand': this.brandForProduct(product).attributes['name'],
        'url': product.attributes['web-url']
      }

      if (category) {
        schema['category'] = category
      }

      const activeVariant = this.activeVariantForProduct(product)

      if (activeVariant) {
        schema['color'] = product.attributes['variants-count'] > 1 ? activeVariant.attributes['name'] : null
        schema['offers'] = {
          '@type': 'Offer',
          'price': activeVariant ? humanizePrice(activeVariant.attributes['price']) : null,
          'priceCurrency': I18n.currency,
          'availability': activeVariant && activeVariant.attributes['inventory'] > 0 ? 'http://schema.org/InStock' : null
        }
      }
      return schema
    }
  }
}
</script>
